export default {
    name: 'Footer',

    methods: {
        initCopyright() {
            if (process.env.FOOTER_COPYRIGHT) {
                let footerCopyright = document.querySelector('.footer .copy');
                if (footerCopyright) {
                    footerCopyright.innerHTML = footerCopyright.innerHTML + process.env.FOOTER_COPYRIGHT;
                }
            }
        },

        scrollToElement(element) {
            if (element) {
                requestAnimationFrame(() => {
                    const yOffset = -document.querySelector('#header').offsetHeight;
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

                    window.scrollTo({top: y, behavior: 'smooth'});
                });
            }
        },

        scrollToHomeOrdersBlock() {
            document.dispatchEvent(new CustomEvent('headerHideMobileMenu'));
            const ordersBlock = document.getElementById('orders-block');
            
            if (ordersBlock) {
                this.scrollToElement(ordersBlock);
                return;
            }

            location = '/#orders-block';
        }
    },

    created() {
        this.initCopyright();
    }
}
